export function getParamsLocation() {
  const urlParams = window.location.search;
  const params: { [index: string]: string } = {};
  urlParams
    .replace('?', '')
    .split('&')
    .map(param => param.split('='))
    .forEach(([key, value]) => {
      params[key] = value;
      return params;
    });
  return params;
}

export function checkQueryParamName(param: string) {
  const params = getParamsLocation();
  if (params) return params[param];
}

export function getQueryParamValue(param: string): string | null {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(param);
}
